var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 158,
    viewBox: "0 0 76 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.e{fill:none;}.c{stroke:#000041;stroke-width:24px;}.d{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 76,
    height: 158
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-73 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 73,
    cy: 73,
    r: 73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 73,
    cy: 73,
    r: 61
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCurve);
export default __webpack_public_path__ + "static/media/blueCurve.2db0529635e5b3a119d3f613e754b736.svg";
export { ForwardRef as ReactComponent };